export enum GeneralNavigationSkillToolName {
  BrowserHistory = 'browser-history',
}
